import packfile from '~/package.json';

export default function setBuildNumber() {
  const pkage = JSON.parse(JSON.stringify(packfile));
  const name = pkage.name;
  const version = pkage.version;

  // need to check that the bulid version file is there
  try {
    var buildtxt = require('../../build.json');
    const build = JSON.parse(JSON.stringify(buildtxt));
    const displayName = name + '.' + version + '.js (' + build.build + ')';
    if (window.console) {
      const con = window.console;
      con.log(displayName); // hack for production, so the version console doesn't get removed by webpack
      window.apeJsClientBuildNumber = displayName;
    }
  } catch (err) {
    if (window.console) {
      console.error('Build number not available');
    }
  }
}

setBuildNumber();
